import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Configuration, CreateCompleteCompanyStaffDto, PmSearchParamsDTO, PmSearchResponseDto, PmsApi, UpdateCompleteCompanyStaffDto } from '@inosio/payments-sdk';
import { selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import {IpaUserExtended} from '../../../shared/sagas/auth/authSlice';
import { createPmStaff, deletePmStaff, getAssociatedPMs, setAssociatedPMs, getAssociatedPMsFailed, setCreatePMStatus, setDeletePMStatus, setUpdatePMStatus, updatePmStaff } from './accountManagementSlice';

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestSearchPms(accessToken: string, uuid: string, pmSearchParamsDTO: PmSearchParamsDTO) {
  apiConfig.accessToken = accessToken;
  const ipaPmAPI = new PmsApi(apiConfig);
  return ipaPmAPI.searchPms(uuid, pmSearchParamsDTO);
}

export function requestCreatePmStaff(accessToken: string, createPmDto: CreateCompleteCompanyStaffDto, adminPmUuid: string) {
  apiConfig.accessToken = accessToken;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.createPmStaff(adminPmUuid, createPmDto);
}

export function requestUpdatePmStaff(accessToken: string, uuid: string, updatePMDto: UpdateCompleteCompanyStaffDto, adminPmUuid: string) {
  apiConfig.accessToken = accessToken;
  const ipaPmAPI = new PmsApi(apiConfig);

  return ipaPmAPI.updatePmStaff(adminPmUuid, uuid, updatePMDto);
}

export function requestDisablePM(accessToken: string, pmUuidToDisable: string, currentCompanyAdmin: string) {
  apiConfig.accessToken = accessToken;
  const ipaPmAPI = new PmsApi(apiConfig);
  return ipaPmAPI.disableCompanyStaff(currentCompanyAdmin, pmUuidToDisable);
}

export function* handleSearchPmStaff(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<PmSearchResponseDto> = yield call(requestSearchPms, currentUser.accessToken, currentUser.currentProfile.uuid, action.payload);
    const { data } = response;
    yield put(setAssociatedPMs(data));
  } catch (error: any) {
    yield put(getAssociatedPMsFailed({ message: error?.response?.data?.message }));
  }
}

export function* handleCreatePM(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestCreatePmStaff, currentUser.accessToken, action.payload, currentUser.currentProfile.uuid);
    // make it wait for this call to execute
    yield put(setCreatePMStatus({}));
  } catch (error) {}
}

export function* handleEditPmStaff(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestUpdatePmStaff, currentUser.accessToken, action.payload.uuid, action.payload.data, currentUser.currentProfile.uuid);
    // make it wait
    yield put(setUpdatePMStatus({}));
  } catch (error) {}
}

export function* handleDeletePM(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestDisablePM, currentUser.accessToken, action.payload.uuid, currentUser.currentProfile.uuid);
    // make it wait
    yield put(setDeletePMStatus({}));
  } catch (error) {}
}

export function* pmAccountManagementSaga() {
  yield takeLatest(createPmStaff.type, handleCreatePM);
  yield takeLatest(updatePmStaff.type, handleEditPmStaff);
  yield takeLatest(deletePmStaff.type, handleDeletePM);
  yield takeLatest(getAssociatedPMs.type, handleSearchPmStaff);
}
